import React from "react";
import PropTypes from "prop-types";
import "./SplitButtonCascade.scss";
import { SafeSVG } from "../svg/SafeSVG";

/**
 * Cascade, multi-level dropdown for SplitButton
 * @param {object} item - item with nested items
 */
const SplitButtonCascadeComponent = (props) => {

  const handleClick = (e, index, item) => {
    if (item.disabled || item.disableClick) {
      e.preventDefault?.();
      e.stopPropagation?.();
      e.nativeEvent?.stopImmediatePropagation?.();
      return;
    } else {
      props.item.onItemClick(index, item);
    }
  };

  return (
    <>
      <span
        className={`k-icon k-font-icon k-i-arrow-chevron-${props.item.direction ?? "right"
          }`}
        data-tooltip=""
      ></span>
      <span className="k-menu-link-text" data-tooltip="">
        {props.item.text}
      </span>

      <ul
        className={`split-button-cascade ${props.item.direction ?? "right"}`}
        data-tooltip=""
      >
        {props.item.items.map((x, index) => {
          return (
            <li
              key={index}
              className="k-item k-menu-item"
              role="menuitem"
              onClick={(e) => handleClick(e, index, x)}
              data-tooltip=""
            >
              <span
                tabIndex="-1"
                className={`k-link k-menu-link${x.disabled ? " k-disabled" : ""}`}
                data-tooltip=""
              >
                <SafeSVG src={x.imageUrl} className="k-icon k-font-icon" />
                <span className="k-menu-link-text" data-tooltip="">
                  {x.text}
                </span>
              </span>
            </li>
          );
        })}
      </ul>
    </>
  );
};

SplitButtonCascadeComponent.propTypes = {
  item: PropTypes.shape({
    direction: PropTypes.string.isRequired,
    onItemClick: PropTypes.func,
    text: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        imageUrl: PropTypes.string,
      })
    ),
  }),
};

export default SplitButtonCascadeComponent;
